//
//
//
//
//
import earth from '@comp/Map/earth1'; // import cloudImage from '@comp/Map/cloudImage'

export default {
  name: 'mars',
  components: {
    earth: earth // cloudImage

  }
};